/**
 * Converts string to camel case
 *
 * @param {string} string
 * @returns {string} A camelized string
 */
export const toCamelCase = <T extends string>(string: T) => {
  let out = '';
  let upperNext = false;

  for (const ch of string) {
    if (ch === '-' || ch === '_' || ch <= ' ') {
      upperNext = out.length > 0;
      continue;
    }

    if (out.length === 0) {
      out += ch.toLowerCase();
    } else {
      out += upperNext ? ch.toUpperCase() : ch;
    }

    upperNext = false;
  }

  return out as string;
};
